export default __webpack_public_path__ + "static/media/Ring of the Jungle Cat.d17ee13e.jpg";